import swal from "sweetalert";
import Web3EthContract from "web3-eth-contract";
import TokenContract from '../getAbis/token.json'
import GovernanceContract from '../getAbis/governance.json'
import StakeContract from '../getAbis/stake.json'

export const claimFund = async (account, isClaimed, proposal_id) => {
    if (isClaimed) {
        // if (proposalData.claimed) {
        swal({
            title: "ERROR : Already Claimed",
            text: "Funds already claimed",
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
        });
    } else {
        const { ethereum } = window;
        Web3EthContract.setProvider(ethereum);
        const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);

        await governance_contract.methods.claimFund(proposal_id).estimateGas({
            // await governance_contract.methods.claimFund(proposalData.key).estimateGas({
            from: account
        }).then(async function (gasAmount) {
            let tx = await governance_contract.methods.claimFund(proposal_id).send({
                // let tx = await governance_contract.methods.claimFund(proposalData.key).send({
                from: account
            }, function (error, tx) {
                if (error) {
                    swal({
                        title: "Error Found",
                        text: error.message,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Close",
                        closeOnConfirm: false
                    });
                } else {
                    swal({
                        title: "Claimed Successfully",
                        text: "Please wait for wallet confirmations.",
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Close",
                        closeOnConfirm: false
                    });
                }
            });
            // setRefresh(!refresh)
        }).catch(function (error) {
            if (error.message.includes('eth_estimateGas')) {
                swal({
                    title: "Error Found",
                    text: 'Insufficient Funds For Transaction',
                    icon: "error",
                    showCancelButton: false,

                    confirmButtonText: "Close",
                    closeOnConfirm: false
                });
            } else {
                swal({
                    title: "Error Found",
                    text: error.message,
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Close",
                    closeOnConfirm: false
                });
            }
        });
    }
}